import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import LanguageTexts from '../../../common/language';
import { ChangePasswordInput, RootState } from '../../../common/types';
import { changePassword, resetChangePassword } from '../profile.slice';
import ChangePasswordForm from './ChangePasswordForm';

const ChangePasswordPage: React.FC = (): JSX.Element => {
  const { profile: profileTxt } = LanguageTexts;
  const dispatch = useDispatch();
  const {
    changePassword: { success, errors, loading },
  } = useSelector((state: RootState) => state.profile);

  function onSubmit(data: ChangePasswordInput) {
    dispatch(changePassword(data));
  }

  useEffect(() => {
    if (success) {
      dispatch(resetChangePassword());
      toast.success(profileTxt.changePasswordSuccessMsg, {
        position: 'top-center',
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  }, [success, profileTxt, dispatch]);

  const changePasswordInit: ChangePasswordInput = {
    password: '',
  };

  return (
    <>
      <h3 className="text-8 font-weight-400 mb-4">
        {profileTxt.changePasswordHeading}
      </h3>
      {!success ? (
        <ChangePasswordForm
          onSubmit={onSubmit}
          errors={errors}
          loading={loading}
          initialValues={changePasswordInit}
        />
      ) : null}
    </>
  );
};

export default ChangePasswordPage;
